require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-ibeacon-outside-retail-5-fields-where-bluetooth-beacons-can-be-game-changers.json") })
        }
      }, "path---blog-ibeacon-outside-retail-5-fields-where-bluetooth-beacons-can-be-game-changers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-ibeacon-outside-retail-5-fields-where-bluetooth-beacons-can-be-game-changers!./.cache/json/blog-ibeacon-outside-retail-5-fields-where-bluetooth-beacons-can-be-game-changers.json
// module id = 883
// module chunks = 231608221292675